(() => {
  const storageKey = 'navelis:promo-popup-dismissed';
  // Draft-only preview for repeatable QA without clearing a visitor's storage.
  const preview = window.Shopify?.theme?.role === 'unpublished' && new URLSearchParams(window.location.search).get('promo-preview') === '1';

  const initialize = (dialog) => {
    if (!dialog || dialog.dataset.promoPopupReady === 'true') return;
    dialog.dataset.promoPopupReady = 'true';

    const dismiss = () => {
      if (dialog.open) dialog.close();
      const days = Number(dialog.dataset.dismissDays) || 7;
      try {
        if (!preview) localStorage.setItem(storageKey, String(Date.now() + days * 86400000));
      } catch (_) {
        // Storage is optional; the native dialog remains fully functional.
      }
    };

    dialog.querySelectorAll('[data-promo-popup-close]').forEach((button) => button.addEventListener('click', dismiss));
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dismiss(); });

    if (dialog.dataset.enabled !== 'true' && dialog.dataset.designMode !== 'true') return;
    let hiddenUntil = 0;
    try { hiddenUntil = Number(localStorage.getItem(storageKey)) || 0; } catch (_) { hiddenUntil = 0; }
    if (hiddenUntil > Date.now() && dialog.dataset.designMode !== 'true' && !preview) return;

    window.setTimeout(() => {
      const open = () => {
        if (!dialog.isConnected || dialog.open) return;
        dialog.showModal();
        dialog.querySelector('[data-promo-popup-close]')?.focus({ preventScroll: true });
      };
      if (document.querySelector('[data-age-gated-storefront][inert]')) {
        document.addEventListener('tempori:age-confirmed', open, { once: true });
      } else open();
    }, Number(dialog.dataset.delay) || 0);
  };

  document.querySelectorAll('[data-promo-popup]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-promo-popup]').forEach(initialize));
})();
